// TODO unit test
export const genFallbackRoute = (baseRoute: string): string => {
  const url = window.location.href
    .split('itrack-habitat/' /*TODO: get from REACT_APP_PUBLIC_URL?*/)
    .slice(-1)[0];
  const route = `${baseRoute}?returnUrl=${url}`;
  return route;
};

// TODO use useSearchParams
export const getQueryParams = (): URLSearchParams => {
  return new URLSearchParams(window.location.search);
};

// TODO use useSearchParams
export const getQueryParam = (name: string): string | null => {
  const params = getQueryParams();
  return params.get(name);
};
